
















import { Vue, Component, Prop } from 'vue-property-decorator'
import { mapGetters, mapActions } from 'vuex'
import { APP_MODULE, IS_LOADING, SET_IS_LOADING } from '../../../store/modules/app/constant'

@Component({
  methods: {
    ...mapActions(APP_MODULE, [SET_IS_LOADING])
  },
  computed: {
    ...mapGetters(APP_MODULE, [IS_LOADING])
  }
})
export default class Button extends Vue {
  @Prop({ type: String, default: '' }) readonly dataAction?: string
  @Prop({ type: String, default: '' }) readonly dataFnAction?: string
  @Prop({ type: [Object, String], default: '' }) readonly dataFnParams?: object
  @Prop({ type: Boolean, default: false }) readonly disableSpacing?: boolean
  @Prop({ type: Boolean, default: false }) readonly disable?: boolean
  @Prop({ type: String, default: '' }) readonly customStyle?: string

  get loading(): boolean {
    return (this as any)[IS_LOADING]
  }
  emitClick() {
    if (!this.loading) {
      (this as any).$emit('click')
    }
  }
  mounted() {
    (this as any)[SET_IS_LOADING](false)
  }
}
